import { makeStyles } from '@material-ui/core/styles';

export const useFilterStyles = makeStyles((theme) => ({
  filter: {
    marginBottom: 15,
  },
  textField: {
    minWidth: 137,
    width: 145,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .MuiFormHelperText-root': {
      position: 'relative',
      marginTop: 4,
    },
    '& input': {
      padding: '10px 12px',
    },
  },
  filterButton: {
    height: 40,
    [theme.breakpoints.down('sm')]: {
      height: 38,
      padding: '12px',
      '& .MuiButton-startIcon': {
        marginLeft: 0,
        marginRight: 8,
      },
    },
  },
}));
